import { configApi } from '@common/config';
import { errorApi } from '@common/error';
import { servicesApi } from '@common/services';
import { configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import inscription from './stores/inscription.slice';

export const store = configureStore({
  reducer: {
    [configApi.reducerPath]: configApi.reducer,
    [errorApi.reducerPath]: errorApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    inscription: inscription,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(
        configApi.middleware,
        errorApi.middleware,
        servicesApi.middleware,
      ),
});

setupListeners(store.dispatch as ThunkDispatch<unknown, unknown, unknown>);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
